import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'servicos/doem',
		component: Base,
		children: [
			{
				path: '',
				name: 'DOEMList',
				component: List,
				meta: {
					path: '/servicos/doem',
					pai: 'Serviços',
					title: 'Admin - DOEM',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'DOEM',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'DOEMNovo',
				component: Form,
				meta: {
					path: '/servicos/doem',
					pai: 'Serviços',
					title: 'Admin - DOEM - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'DOEM',
						class: '',
						active: false,
						url: '/servicos/doem'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'DOEMEditar',
				component: Form,
				meta: {
					path: '/servicos/doem',
					pai: 'Serviços',
					title: 'Admin - DOEM - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'DOEM',
						class: '',
						active: false,
						url: '/servicos/doem'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]